/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import _ from 'underscore';
import hyperlinkHandler from '../../../hyperlink/handler/dashboardHyperlinkHandlerAdhocExecution';
import dashboardWiringStandardIds from '../../../enum/dashboardWiringStandardIds';
import ImageView from '../ImageView';
import $ from "jquery";
import compTraitUtil from './util/componentTraitUtil';

function signalHandler(payload) {
    if (payload.name === dashboardWiringStandardIds.REFRESH_SLOT || payload.name === dashboardWiringStandardIds.APPLY_SLOT) {
        this._renderComponent();
    }
}

export default {
    notify: function (signals) {
        this.model.notify(signals);
        this.model.collection.getDashboardPropertiesComponent().applyParameters();
    },

    refresh: function(){
        this._renderComponent();
        return $.Deferred().resolve();
    },
    _initComponent: function () {
        const self = this;
        this.component = new ImageView({
            model: this.model,
            el: this.$content
        });
        this.$content.click(function (ev) {
            compTraitUtil.triggerLinkOptions(ev,self.model);
            hyperlinkHandler.events.click(ev, compTraitUtil.getParameters(self.model), self);
        });
        this.$content.mouseover(function(ev){
            compTraitUtil.triggerLinkOptions(ev,self.model);
        });
        this.$content.mouseout(function(ev){
            compTraitUtil.triggerLinkOptions(ev,self.model);
        });
        this.listenTo(this.model, 'signal', signalHandler);
        if (this.model.lastPayload) {
            for (var key in this.model.lastPayload) {
                signalHandler.call(this, {
                    name: key,
                    value: this.model.lastPayload[key]
                }, this.model.lastSender[key]);
            }
        }
    },
    /**
     * @memberof imageTrait
     * @access protected
     * @desc on component properties change event handler. re-Renders component after properties were changed through properties dialog.
     */
    _onComponentPropertiesChange: function (changedProperties) {
        if (!_.isEmpty(_.omit(changedProperties, 'selected', 'hovered'))) {
            this._renderComponent();
        }
    },
    _renderComponent: function () {
        var uri = this.model.getParametrizationResult('url', this.paramsModel.attributes, {tolerateMissing: true});
        this.component.render(uri);
        this.trigger('componentRendered', this);
    },
    _onRefreshClick: function () {
        this._renderComponent();
    }
};